import React, { useState } from 'react';
import Modal from 'react-modal';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
//pages
import Checkout from './pages/Checkout';
import Error from './pages/Erro';
import Success from './pages/Success';
import { UseContext } from './context/useContext';

Modal.setAppElement('#root');

export default function App() {
	const [errorMessage, setErrorMessage] = useState('');

	return (
		<UseContext.Provider value={{ errorMessage, setErrorMessage }}>
			<BrowserRouter>
				<Routes>
					<Route exact path='/' element={<Checkout />} />
					<Route exact path='/success' element={<Success />} />
					<Route exact path='/error' element={<Error />} />
				</Routes>
			</BrowserRouter>
		</UseContext.Provider>
	);
}
